<template>
  <a-row type="flex" class="timeBar">
    <a-col>
      <a-radio-group v-model="key" @change="_handleTabChange" buttonStyle="solid">
        <a-radio-button v-for="item in timeArr" :value="item.key" :key="item.key">{{ item.text }}</a-radio-button>
      </a-radio-group>
    </a-col>
    <a-col>
      <a-input-group compact v-if="dataPicker" style="margin-left: 15px">
        <a-radio-group buttonStyle="solid" v-model="key" @change="_handleTabChange">
          <a-radio-button :value="-1">自定义时间</a-radio-button>
        </a-radio-group>
        <a-range-picker
            v-model="range"
            style="width: 250px"
            @change="_handleTimeChange"
            format="YYYY-MM-DD"
        />
      </a-input-group>
    </a-col>
  </a-row>
</template>

<script>
import moment from "moment";

export default {
  name: "TimeBar",
  props: {
    clean: {
      type: Boolean,
      default: false
    },
    dataPicker: {
      type: Boolean,
      default: true
    },
    timeArr: {
      type: Array,
      default: () => {
        return [
          {
            key: 0,
            text: "全部",
            value: []
          },
          {
            key: 1,
            text: "昨天",
            value: [
              moment()
                  .subtract(1, "days")
                  .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          },
          {
            key: 2,
            text: "过去7天",
            value: [
              moment()
                  .subtract(7, "days")
                  .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          },
          {
            key: 3,
            text: "过去一月",
            value: [
              moment()
                  .subtract(1, "months")
                  .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          },
          {
            key: 4,
            text: "过去一年",
            value: [
              moment()
                  .subtract(12, "months")
                  .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          }
        ];
      }
    }
  },
  watch: {
    clean() {
      console.log(this.clean)
      if (this.clean) {
        this.key = this.timeArr[0].key;
        this.range = []
      }
    },
    key() {
      this.$emit('timeclean')
    },
    range() {
      this.$emit('timeclean')
    }
  },
  data() {
    return {
      key: this.timeArr[0].key,
      range: [],
      timeclean:this.clean
    };
  },
  methods: {
    init() {
      this._handleTabChange();
    },
    _handleTabChange() {
      if (this.key === -1) {
        if (this.range.length === 2) {
          this._handleTimeChange();
        }
        return;
      }
      this.$emit("change", {
        value: this.timeArr[this.key].value,
        text: this.timeArr[this.key].text
      });
    },
    _handleTimeChange() {
      if (this.range[0] && this.range[1]) {
        this.key = -1;
        this.$emit("change", {
          value: [
            this.range[0].format("YYYY-MM-DD"),
            this.range[1].format("YYYY-MM-DD")
          ],
          text: "自定义"
        });
      }
    }
  }
};
</script>
